<template>
  <v-dialog v-model="dialog" persistent width="400px" @keydown.esc="onDialogClose">
    <v-row no-gutters>
      <v-col>
        <v-card flat color="white" v-if="userAccountClone != null">
          <v-card-title class="dialog-header-title">Edit user account</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <span>First name:</span>
                <input class="form-control" v-model="userAccountClone.first_name" />
              </v-col>

              <v-col cols="12">
                <span>Last name:</span>
                <input class="form-control" v-model="userAccountClone.last_name" />
              </v-col>

              <v-col cols="12">
                <span>Phone number:</span>
                <input class="form-control" v-model="userAccountClone.phone_number" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row justify="end">
              <v-btn
                @click="onSave"
                class="mr-2 font-weight-bold"
                color="primary"
                tile
                depressed
                >SAVE</v-btn
              >
              <v-btn
                @click="onDialogClose"
                class="ml-2 font-weight-bold"
                color="error"
                tile
                depressed
                >CLOSE</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import constant from "../../const";
export default {
  props: ["dialog", "contact", "useraccount"],

  data() {
    return {
      userAccountClone: null,
    };
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.userAccountClone = this.useraccount;
      }
    },
  },

  methods: {
    onSave() {
      var response = null;

      this.$root.blockUIshow = true;

      this.$auth
        .put("/user/" + this.userAccountClone.uid, this.userAccountClone)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          response = err.response;
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            // re-initialise user
            this.$root.re_init_user(response.data.uid);
          } else {
            console.log(response);
          }
          this.$root.blockUIshow = false;
        });
    },

    onDialogClose() {
      this.$emit("dialog-close", constant.DIALOG_USER_ACCOUNT);
    },
  },

  computed: {},
};
</script>

<style></style>
